<script lang="ts">
	import { format } from 'svelte-i18n';
	import { SidepanelContent, Stack, LabelListV2, AdvancedCardV2 } from '@Shelly/shelly-design-system';
	import DeviceInList from 'src/components/Lists/Devices/DeviceInList.svelte';

	export let id;
	export let alarm;
	export let roomsWithSensors = [];
	export let missingDevices = [];
	export let hasZoneLabels = false;

	const zoneA11y = { isInteractive: false };
</script>

<SidepanelContent>
	<Stack gap="s">
		{#if missingDevices.length}
			{#each missingDevices as device, ind}
				<AdvancedCardV2
					isCondensed
					title={$format('missing_device_label', {
						default: 'Missing Device',
					})}
					avatar={{
						icon: 'text-warning fas fa-warning',
					}}
				>
					<svelte:fragment slot="main">
						<LabelListV2
							a11yProps={zoneA11y}
							size="s"
							labelList={[{ value: device.id, icon: 'fa-solid fa-microchip' }]}
						/>
					</svelte:fragment>
				</AdvancedCardV2>
			{/each}
		{/if}

		{#each roomsWithSensors as room, ind}
			{#if room.devices}
				{#each room.devices as device}
					<DeviceInList {device} type="group" variant="condensed" />
					{#if hasZoneLabels && device._alarmZoneLabel}
						<LabelListV2
							a11yProps={zoneA11y}
							size="s"
							labelList={[{ value: device._alarmZoneLabel, icon: 'fa fa-vector-square' }]}
						/>
					{/if}
				{/each}
			{/if}
		{/each}
	</Stack>
</SidepanelContent>
